
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"cross\" ><path d=\"M24.008 21.852l8.969-8.968L31.093 11l-8.969 8.968L13.156 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/cross.svg
// module id = 485
// module chunks = 0 1